<template>
    <rkm-overlay>
        <rkm-layout-body title="Relatório de usuários">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/cadastro/relatorio-usuario/List'

export default {
    components: { List },
}
</script>